import { render, staticRenderFns } from "./listTarjasNative.vue?vue&type=template&id=639cd08a&"
import script from "./listTarjasNative.vue?vue&type=script&lang=js&"
export * from "./listTarjasNative.vue?vue&type=script&lang=js&"
import style0 from "./listTarjasNative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports